module.exports = __webpack_public_path__ + "public/img/logo-vertical-dark.f48723ce.svg";